let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("eIR2q")]).then(() => parcelRequire('hA9EZ'));